import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { BackHeader, PageTemplate } from '@_widgets/common';

import { announcementApi, announcementModel } from '@_entities/system';

import { SkeletonUI } from '@_shared/ui';
import { Typography } from '@_shared/ui/Typography';

import * as S from './AnnouncementPage.style';

export function AnnouncementPage() {
	const [data, setData] = useState<announcementModel.IAnnouncementListResponse>();
	const navigate = useNavigate();

	useEffect(() => {
		announcementApi.getAnnouncementList().then(({ data: responseData }) => {
			setData(responseData);
		});
	}, []);

	return (
		<PageTemplate header={<BackHeader>공지사항</BackHeader>} nav={false}>
			{/* Skeleton UI */}
			{data === undefined ? (
				<>
					<S.AnnouncementList>
						<S.AnnouncementItem>
							<SkeletonUI width="80%" height="24px" borderRadius="8px" />
							<SkeletonUI width="80px" height="24px" borderRadius="8px" />
						</S.AnnouncementItem>
						<S.AnnouncementItem>
							<SkeletonUI width="80%" height="24px" borderRadius="8px" />
							<SkeletonUI width="80px" height="24px" borderRadius="8px" />
						</S.AnnouncementItem>
						<S.AnnouncementItem>
							<SkeletonUI width="80%" height="24px" borderRadius="8px" />
							<SkeletonUI width="80px" height="24px" borderRadius="8px" />
						</S.AnnouncementItem>
						<S.AnnouncementItem>
							<SkeletonUI width="80%" height="24px" borderRadius="8px" />
							<SkeletonUI width="80px" height="24px" borderRadius="8px" />
						</S.AnnouncementItem>
						<S.AnnouncementItem>
							<SkeletonUI width="80%" height="24px" borderRadius="8px" />
							<SkeletonUI width="80px" height="24px" borderRadius="8px" />
						</S.AnnouncementItem>
						<S.AnnouncementItem>
							<SkeletonUI width="80%" height="24px" borderRadius="8px" />
							<SkeletonUI width="80px" height="24px" borderRadius="8px" />
						</S.AnnouncementItem>
					</S.AnnouncementList>
				</>
			) : (
				<>
					<S.AnnouncementList>
						{data.results.map((announcement, index) => (
							<S.AnnouncementItem
								key={`${announcement.id} announcement`}
								onClick={() => {
									navigate(`/settings/announcement/${announcement.id}`);
								}}
								isLastItem={data.results.length - 1 === index}
							>
								<Typography type="title-medium" color="font-primary">
									{announcement.title}
								</Typography>
								<Typography type="label-large" color="font-tertiary">
									{announcement.createdDate}
								</Typography>
							</S.AnnouncementItem>
						))}
					</S.AnnouncementList>
				</>
			)}
		</PageTemplate>
	);
}
